export default __webpack_public_path__ + "media/images/user-d1d62b9ef428744946d3d666a153f0e8.svg";